import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "order-page-box"
  }, [_c('div', {
    staticClass: "order-page-breadcrumb"
  }, [_c('a-breadcrumb', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "separator": ">"
    }
  }, [_c('a-breadcrumb-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MaintenanceComplianceOfficerPage'
      }
    }
  }, [_vm._v(_vm._s(_vm.t("商品GPSR信息维护")))])], 1), _c('a-breadcrumb-item', [_vm._v(_vm._s(_vm.t("新增商品GPSR信息")))])], 1)], 1), _c('categorize-box', {
    attrs: {
      "data": [],
      "componentMap": {
        0: 'FormPage'
      },
      "value": String(_vm.FormPage)
    }
  }, [_c('FormPage', {
    tag: "component",
    attrs: {
      "type": "add"
    }
  })], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };